import { Grid, GridColumn, GridColumnMenuGroup } from "@progress/kendo-react-grid";
import { Api } from "../../../redux/api/BaseApi";
import { TicketApi } from "../../../redux/api/TicketApi";
import { toDigital } from "../../../utils/utils";
import { FileApi } from '../../../redux/api/FileApi';
import { FileType } from '../../../types/File/FileType';
import { SimpleSpinny } from "../../Nav/Spinny";
import React, { useEffect } from "react";
import {
    setGroupIds,
    getGroupIds,
    setExpandedState,
} from "@progress/kendo-react-data-tools";
import { GroupDescriptor, SortDescriptor, process } from "@progress/kendo-data-query";
import { ITemplateAction } from "../../../types/Ticket/ITemplate";

const TemplateActions: React.FC<TemplateActionProps> = (props) => {
    const { data: isFileActive } = FileApi.useIsActiveQuery(FileType.Call_Action_Internal)
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const { data: actions, isFetching } = TicketApi.useGetTemplateActionsQuery(props.templateId, { skip: !props.templateId })

    const initialDataState = {
        take: 10,
        skip: 0,
        groupable: false,
        sort: [{ field: "Step_Order", dir: "desc" } as SortDescriptor, { field: "Order", dir: "desc" } as SortDescriptor]
    };
    const [dataState, setDataState] = React.useState(initialDataState);
    // const bindData = React.useMemo(() => {
    //     return (props.templateId && actions?.map(a => { return { ...a, Bill_Time: toDigital(a.Billable_Time), Non_Bill_Time: toDigital(a.Non_Billable_Time) } })) || [];
    // }, [dataState, actions]);
    const bindData = (props.templateId && actions?.map(a => { return { ...a, Bill_Time: toDigital(a.Billable_Time), Non_Bill_Time: toDigital(a.Non_Billable_Time) } })) || [];

    const processWithGroups = (data, dataState) => {
        const newDataState = process(data, dataState);
        setGroupIds({
            data: newDataState.data,
            group: dataState.group,
        });
        return newDataState;
    };
    const onDataStateChange = React.useCallback((event) => {
        const newDataState = processWithGroups(bindData, event.dataState);
        setDataState(event.dataState);
        setResultState(newDataState);
    }, []);

    const [resultState, setResultState] = React.useState(
        processWithGroups(bindData, initialDataState)
    );

    //Group the grid if this is a workflwo template
    useEffect(() => {
        setDataState(d => {
            return {
                ...d, group: props.isWorkflow ? [{
                    field: "Step_Name",
                    compare: (a: ITemplateAction, b: ITemplateAction) => a.Step_Order < b.Step_Order ? 1 : -1,
                } as GroupDescriptor] : [],
                sort: props.isWorkflow ? [{ field: "Order", dir: "desc" } as SortDescriptor] : [{ field: "Order", dir: "asc" } as SortDescriptor]
            }
        });
    }, [props.isWorkflow])

    if (!props.templateId) return <></>;

    return (<>
        {/* dataState:{JSON.stringify(dataState)} */}
        {/* props.isWorkflow:{JSON.stringify(props)} */}
        {isFetching
            ? <SimpleSpinny />
            : <Grid
                data={process(bindData || [], dataState)}
                total={resultState.total}
                onDataStateChange={onDataStateChange}
                {...dataState}
                sortable={false}
                groupable={false}
                pageable={true}
                reorderable={true}>
                <GridColumn field="Action_Notes" title="Notes" width={undefined} />
                {/* Attachment column */}
                {isFileActive && <GridColumn field="File_Count" title="" width={40} headerClassName="template-attach-column" headerCell={(c) => {
                    return <span className="k-font-icon k-i-attachment p-1"></span>
                }} />}
                <GridColumn field="Bill_Time" title={userProfile?.Features?.Non_Bill_Time ? "Bill" : "Time"}
                    width={80} />
                {userProfile?.Features?.Non_Bill_Time && <GridColumn field="Non_Bill_Time" width={80} title='Non Bill' />}

            </Grid>}
    </>)
}

type TemplateActionProps = {
    templateId: number
    isWorkflow: boolean
}

export default TemplateActions;